import React from 'react';
import TopPanel from "../toppanel.js";
import ReportContent from "./ReportContent.js";

module.exports = React.createClass({

    componentDidMount: function () {
        HC_SubscribeHammerEvent(this.refs.panel, "swiperight", this.props.onGoBack);
    },

    componentWillUnmount: function () {
        HC_UnsubscribeHammerEvent(this.refs.panel, "swiperight");
    },

    render: function() {
        var licon, liconClick, rbutton, reportContent, header;

        var deviceType = HC_DeviceType();
        var item = HC_GetItemById(this.props.data, this.props.selectedId);

        if (deviceType === HC_CONST.SCR_PHONE) {
            licon = "fa-angle-left";
            liconClick = this.props.onGoBack;
        }
        if (item && !this.props.hideContent) {
            header = item.name;
            reportContent =
                 (<ReportContent link={item.link}/>);
            rbutton = {
                items: [
                    /*{
                        name: 'Download as PDF',
                        action: this.handleDownloadPDF,
                        icon: "fa-file-pdf-o "
                     },*/
                    {
                        name: HC_LANG.REP_QR_CODE,
                        action: this.props.onShowQR,
                        icon: "fa-qrcode"
                    },
                    {
                        name: HC_LANG.REP_SHARE_LINK,
                        action: this.props.onShareLink,
                        icon: "fa-share-alt"
                    },
                    {
                        name: HC_LANG.REP_DEL_REP,
                        action: this.props.onDelete,
                        icon: "fa-trash-o"
                    }
                ]
            };
        } else {
            header = HC_LANG.CHL_EMPTY;
        }

        return (
            <div className="hc-internal-panel">
                <TopPanel text={header} licon={licon} onLiconClick={liconClick} rbutton={rbutton}/>
                <div id="main-report-view" ref="panel"
                     style={{position:"absolute", width:"100%", top:"60px", bottom:"0",overflowX:"hidden", overflowY:"auto", WebkitOverflowScrolling:'touch'}}>
                    {reportContent}
                </div>
            </div>
        );
    }
});



// WEBPACK FOOTER //
// ./reports/MainReportView.js